import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { ExerciseModel } from '@generativ/much-smarter-models';

import { ExerciseService } from '../../shared/exercise.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { SpinnerComponent } from '../../../../../shared/spinner/spinner.component';

@Component({
    selector: 'app-get-started',
    templateUrl: './get-started.component.html',
    styleUrls: ['./get-started.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, SpinnerComponent, AsyncPipe]
})
export class GetStartedComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  exercise: Observable<ExerciseModel>;
  waiting = false;
  exerciseId: number;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private exerciseService: ExerciseService) {
  }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.params.subscribe((params) => {
       if (params['exerciseId']) {
         this.exerciseId = +params['exerciseId'];
         this.exercise = this.exerciseService.getExercise(this.exerciseId);
       }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleGetStarted() {
    this.waiting = true;
    this.subscriptions.add(this.exerciseService.startExercise(this.exerciseId).subscribe(
      () => {
        this.router.navigate([`../practice`], {relativeTo: this.activatedRoute});
        this.waiting = false;
      }
    ));
  }
}
